import React, { useEffect, useState } from "react";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import StyledGrid from "components/simple/StyledGrid";
import { StyledPaper, StyledForm } from "./styled";

interface Props {
  setSearchValue(a: string): void;
  placeholder: string;
  defaultValue?: string;
}

export default function Search({
  setSearchValue,
  placeholder,
  defaultValue = ""
}: Props): JSX.Element {
  const [value, setValue] = useState(defaultValue);
  const [timer, setTimer] = useState(0);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const newValue = event.target.value;
    setValue(newValue);

    clearTimeout(timer);

    setTimer(
      setTimeout(() => {
        setSearchValue(newValue);
      }, 200)
    );
  };

  const handleSubmit = (event: React.ChangeEvent<HTMLFormElement>): void => {
    event.preventDefault();
  };

  return (
    <>
      <StyledGrid marginTop={"64px"} />
      <StyledPaper>
        <StyledForm onSubmit={handleSubmit}>
          <IconButton type="submit" aria-label="search">
            <SearchIcon />
          </IconButton>
          <InputBase
            data-testid="search-input"
            fullWidth
            placeholder={placeholder}
            value={value}
            onChange={handleChange}
            inputProps={{ "aria-label": "search input" }}
          />
        </StyledForm>
      </StyledPaper>
    </>
  );
}
